import {ComponentType} from 'react';
import FabContact from '../../../assets/icons/FabContact';
import FabNavigate from '../../../assets/icons/FabNavigate';
import FabEventPage from '../../../assets/icons/FabEventPage';
import FabCancelTicket from '../../../assets/icons/FabCancelTicket';
import FabWallet from '../../../assets/icons/FabWallet';
import {TEticketData} from '../../../redux/eTicket/eTicket.type';

type IconComp = ComponentType<{size?: number; fill?: string; className?: string}>;

export interface FabMenuItem {
    key: string;
    label: string;
    Icon: IconComp;
    danger?: boolean;
    onClick?: () => void;
}

interface GetFabMenuParams {
    data: TEticketData;
    t: (key: string) => string;
    openContact: () => void;
    openNavigate: () => void;
    openWallet?: () => void;
    isSubscription?: boolean;
    /* The distinct venues of the subscription events, already resolved by the caller */
    subscriptionVenues?: string[];
}

// temporarily hidden, set to true to bring the wallet action back
const showWalletAction = true;

const openUrl = (url: string) => window.open(url, '_blank', 'noopener,noreferrer');
export const cancelTicket = (cancel: string, reason: string, t: (key: string) => string) => {
    if(cancel) {
        openUrl(cancel);
    } else {
        alert(reason || t('actionCancelTicketWarning'));
    }
};

export function getFabMenu({data, t, openContact, openNavigate, openWallet, isSubscription, subscriptionVenues = []}: GetFabMenuParams): FabMenuItem[] {
    const eventPage = data.links?.eventPage;
    const cancelAllowed = data.cancel?.allowed;
    const cancel = data.links?.cancel;
    const hasContact = Boolean(data.producer?.phone || data.producer?.email || data.order?.phone || data.order?.email);
    const hasVenue = Boolean(data.event?.address || data.event?.location);
    // A subscription shows navigation only when all of its events are known to share one venue.
    // An empty list means the events have not been loaded, not that there is a single venue —
    // navigating to the season's own address would send the member to the wrong place.
    const hasNavigate = hasVenue && (!isSubscription || subscriptionVenues.length === 1);

    const items: FabMenuItem[] = [];
    if(cancelAllowed)
        items.push({key: 'cancelTicket', label: t(isSubscription ? 'actionCancelSubscription' : 'actionCancelTicket'), Icon: FabCancelTicket, danger: true, onClick: () =>  cancelTicket(cancel, data.cancel?.reason, t)});
    if(hasContact)
        items.push({key: 'contact', label: t('actionContact'), Icon: FabContact, onClick: openContact});
    if(showWalletAction && openWallet)
        items.push({key: 'addToWallet', label: t('actionAddToWallet'), Icon: FabWallet, onClick: openWallet});
    if(eventPage)
        items.push({key: 'eventPage', label: t(isSubscription ? 'actionSeasonPage' : 'actionEventPage'), Icon: FabEventPage, onClick: () => openUrl(eventPage)});
    if(hasNavigate)
        items.push({key: 'navigate', label: t('navigate'), Icon: FabNavigate, onClick: openNavigate});
    return items;
}
